import React, { useEffect, useRef, useState } from 'react';
import BarraFiltros, { BotaoConsultar } from './BarraFiltros';
import {
  abrirSeletorImagem,
  obterImagemDaAreaDeTransferencia,
  obterImagemDoEventoDeColagem,
} from '../filePicker';

const usePreviewUrl = (arquivo) => {
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    if (!arquivo) {
      setPreviewUrl('');
      return undefined;
    }

    const objectUrl = URL.createObjectURL(arquivo);
    setPreviewUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [arquivo]);

  return previewUrl;
};

const ZonaArrastoCatalogo = ({ novoProdutoPadrao, handleNovoProdutoChange }) => {
  const [isDragging, setIsDragging] = useState(false);
  const inputRef = useRef(null);
  const previewUrl = usePreviewUrl(novoProdutoPadrao.imagem);

  const abrirSeletorArquivo = async () => {
    await abrirSeletorImagem({
      inputRef,
      onFileSelecionado: (arquivo) => handleNovoProdutoChange('imagem', arquivo),
    });
  };

  const aplicarImagem = (arquivo) => {
    if (!arquivo?.type?.startsWith('image/')) {
      alert('Escolha ou cole um arquivo de imagem valido.');
      return;
    }
    handleNovoProdutoChange('imagem', arquivo);
  };

  const colarImagem = async (evento) => {
    evento?.stopPropagation();
    try {
      const arquivo = await obterImagemDaAreaDeTransferencia();
      if (!arquivo) {
        alert('Nenhuma imagem foi encontrada. Copie uma imagem e tente novamente.');
        return;
      }
      aplicarImagem(arquivo);
    } catch (error) {
      console.warn('Nao foi possivel ler a imagem copiada:', error);
      alert('Nao foi possivel acessar a imagem copiada. Clique na area da foto e use Ctrl+V.');
    }
  };

  const tratarColagem = (evento) => {
    const arquivo = obterImagemDoEventoDeColagem(evento);
    if (!arquivo) return;
    evento.preventDefault();
    aplicarImagem(arquivo);
  };

  const tratarTeclaSeletor = (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    void abrirSeletorArquivo();
  };

  const onDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const onDragLeave = () => setIsDragging(false);

  const onDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      aplicarImagem(e.dataTransfer.files[0]);
    }
  };

  if (novoProdutoPadrao.imagem && previewUrl) {
    return (
      <div className="routine-image-picker">
      <div className="routine-thumb-preview" onPaste={tratarColagem} tabIndex={0}>
        <img
          src={previewUrl}
          alt="Pré-visualização"
          className="routine-thumb-preview__image"
        />
        <button
          type="button"
          className="routine-thumb-preview__remove"
          onClick={() => {
            handleNovoProdutoChange('imagem', null);
            if (inputRef.current) inputRef.current.value = '';
          }}
        >
          x
        </button>
        <input
          ref={inputRef}
          id="file-produto-padrao"
          type="file"
          accept="image/*"
          onChange={(e) => aplicarImagem(e.target.files[0])}
          style={{ display: 'none' }}
        />
      </div>
      <button type="button" className="routine-image-paste-button" onClick={colarImagem}>
        Colar imagem
      </button>
      </div>
    );
  }

  if (novoProdutoPadrao.id && novoProdutoPadrao.url_imagem) {
    return (
      <div className="routine-image-picker">
      <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onPaste={tratarColagem}
        onClick={() => {
          void abrirSeletorArquivo();
        }}
        onKeyDown={tratarTeclaSeletor}
        role="button"
        tabIndex={0}
        className={`routine-dropzone ${isDragging ? 'is-dragging' : ''}`}
      >
        <img
          src={novoProdutoPadrao.url_imagem}
          alt="Foto atual"
          className="routine-dropzone__image"
          loading="lazy"
          decoding="async"
        />
        <div className="routine-dropzone__overlay">Trocar foto</div>
        <input
          ref={inputRef}
          id="file-produto-padrao"
          type="file"
          accept="image/*"
          onChange={(e) => aplicarImagem(e.target.files[0])}
          style={{ display: 'none' }}
        />
      </div>
      <button type="button" className="routine-image-paste-button" onClick={colarImagem}>
        Colar imagem
      </button>
      </div>
    );
  }

  return (
    <div className="routine-image-picker">
    <div
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onPaste={tratarColagem}
        onClick={() => {
          void abrirSeletorArquivo();
        }}
      onKeyDown={tratarTeclaSeletor}
      role="button"
      tabIndex={0}
      className={`routine-dropzone ${isDragging ? 'is-dragging' : ''}`}
    >
      <span className="routine-dropzone__glyph">+</span>
      <span className="routine-dropzone__label">Selecionar foto</span>
      <input
        ref={inputRef}
        id="file-produto-padrao"
        type="file"
        accept="image/*"
        onChange={(e) => aplicarImagem(e.target.files[0])}
        style={{ display: 'none' }}
      />
    </div>
    <button type="button" className="routine-image-paste-button" onClick={colarImagem}>
      Colar imagem
    </button>
    </div>
  );
};

function AbaMeuCatalogo({
  planoAtual,
  isAdmin,
  podeUsarCatalogo,
  setAbaAtiva,
  salvarProdutoPadrao,
  handleNovoProdutoChange,
  novoProdutoPadrao,
  tags,
  isSalvandoProduto,
  produtosPadrao,
  carregandoProdutos,
  temMaisProdutos,
  erroCatalogo,
  filtrarProdutos,
  carregarMaisProdutos,
  excluirProdutoPadrao,
  iniciarEdicaoProduto,
  cancelarEdicao,
}) {
  const bloqueadoNoCatalogo = !podeUsarCatalogo && !isAdmin;
  const [termoBusca, setTermoBusca] = useState('');
  const [categoriaBusca, setCategoriaBusca] = useState('');

  const pesquisarCatalogo = (e) => {
    e.preventDefault();
    filtrarProdutos({ termo: termoBusca, categoriaId: categoriaBusca });
  };

  const limparPesquisa = () => {
    setTermoBusca('');
    setCategoriaBusca('');
    filtrarProdutos();
  };

  return (
    <div className="routine-panel">
      {bloqueadoNoCatalogo ? (
        <div className="routine-callout routine-callout--warm">
          <h2 className="routine-callout__title">Desbloqueie o catálogo de produtos</h2>
          <p className="routine-callout__text" style={{ maxWidth: '680px', marginBottom: '22px' }}>
            Imagine preparar suas postagens com poucos cliques. Com o catálogo padrão, você monta uma base própria
            de produtos e agiliza a criação das ofertas em lote.
            <br />
            <br />
            <strong>Exclusivo para lojistas Prata ou superior.</strong> Faça upgrade para liberar essa área.
          </p>
          <button
            type="button"
            className="routine-btn routine-btn--warning"
            onClick={() => setAbaAtiva('planos')}
          >
            Conhecer planos
          </button>
        </div>
      ) : (
        <>
          <form
            onSubmit={salvarProdutoPadrao}
            className={`routine-form-surface ${novoProdutoPadrao.id ? 'is-highlighted' : ''}`}
          >
            {novoProdutoPadrao.id && (
              <div className="routine-form-banner">Editando produto existente...</div>
            )}

            <div className="routine-field routine-field--media">
              <label className="routine-label">Foto {novoProdutoPadrao.id ? '' : '*'}</label>
              <ZonaArrastoCatalogo
                novoProdutoPadrao={novoProdutoPadrao}
                handleNovoProdutoChange={handleNovoProdutoChange}
              />
            </div>

            <div className="routine-field routine-field--grow">
              <label className="routine-label">Nome do Produto *</label>
              <input
                type="text"
                className="routine-input"
                placeholder="Ex: Leite Integral 1L"
                value={novoProdutoPadrao.nome_produto || ''}
                onChange={(e) => handleNovoProdutoChange('nome_produto', e.target.value)}
              />
            </div>

            <div className="routine-field">
              <label className="routine-label">Categoria *</label>
              <select
                className="routine-select"
                value={novoProdutoPadrao.id_tag || ''}
                onChange={(e) => handleNovoProdutoChange('id_tag', e.target.value)}
              >
                <option value="">Escolha...</option>
                {tags.map((tag) => (
                  <option key={tag.id} value={tag.id}>
                    {tag.nome_tag}
                  </option>
                ))}
              </select>
            </div>

            <div className="routine-actions">
              <button
                type="submit"
                disabled={isSalvandoProduto}
                className={`routine-btn ${novoProdutoPadrao.id ? 'routine-btn--dark' : 'routine-btn--primary'}`}
              >
                {isSalvandoProduto
                  ? novoProdutoPadrao.id
                    ? 'Atualizando...'
                    : 'Salvando...'
                  : novoProdutoPadrao.id
                    ? 'Atualizar'
                    : 'Salvar'}
              </button>

              {novoProdutoPadrao.id && (
                <button
                  type="button"
                  onClick={cancelarEdicao}
                  className="routine-btn routine-btn--soft"
                >
                  Cancelar
                </button>
              )}
            </div>
          </form>

          <BarraFiltros rotulo="Filtros do catalogo" onSubmit={pesquisarCatalogo} acoes={<>
            <BotaoConsultar disabled={carregandoProdutos} />
            {(termoBusca || categoriaBusca) && (
              <button type="button" className="routine-btn routine-btn--soft" onClick={limparPesquisa} disabled={carregandoProdutos}>Limpar</button>
            )}
          </>}>
              <div className="routine-field routine-field--grow">
                <label className="routine-label" htmlFor="catalogo-busca">Produto</label>
                <input
                  id="catalogo-busca"
                  type="search"
                  className="routine-input"
                  placeholder="Nome do produto"
                  value={termoBusca}
                  onChange={(e) => setTermoBusca(e.target.value)}
                />
              </div>

              <div className="routine-field routine-field--grow">
                <label className="routine-label" htmlFor="catalogo-categoria">Categoria</label>
                <select
                  id="catalogo-categoria"
                  className="routine-select"
                  value={categoriaBusca}
                  onChange={(e) => setCategoriaBusca(e.target.value)}
                >
                  <option value="">Todas as categorias</option>
                  {tags.map((tag) => (
                    <option key={tag.id} value={tag.id}>
                      {tag.nome_tag}
                    </option>
                  ))}
                </select>
              </div>

          </BarraFiltros>

          {erroCatalogo && (
            <div className="routine-callout routine-callout--warm" style={{ marginTop: '14px' }}>
              <p className="routine-callout__text" style={{ margin: 0 }}>{erroCatalogo}</p>
            </div>
          )}

          <div className="routine-table-wrap" style={{ marginTop: '24px' }}>
            <table className="routine-table">
              <thead>
                <tr>
                  <th style={{ width: '90px', textAlign: 'center' }}>Imagem</th>
                  <th>Produto</th>
                  <th>Categoria</th>
                  <th style={{ textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {carregandoProdutos && produtosPadrao.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="routine-empty">
                      Carregando produtos...
                    </td>
                  </tr>
                ) : produtosPadrao.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="routine-empty">
                      Nenhum produto foi encontrado.
                    </td>
                  </tr>
                ) : (
                  produtosPadrao.map((produto) => (
                    <tr key={produto.id}>
                      <td style={{ textAlign: 'center' }}>
                        <img
                          src={produto.url_imagem}
                          alt={produto.nome_produto}
                          className="routine-thumb"
                          loading="lazy"
                          decoding="async"
                        />
                      </td>
                      <td style={{ fontWeight: 700, color: '#0f172a' }}>{produto.nome_produto}</td>
                      <td>
                        <span className="routine-tag">{produto.nome_tag}</span>
                      </td>
                      <td>
                        <div className="routine-table__actions">
                          <button
                            type="button"
                            onClick={() => iniciarEdicaoProduto(produto)}
                            className="routine-btn routine-btn--soft"
                          >
                            Editar
                          </button>
                          <button
                            type="button"
                            onClick={() => excluirProdutoPadrao(produto.id)}
                            className="routine-btn routine-btn--danger"
                          >
                            Excluir
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {produtosPadrao.length > 0 && (
            <div className="routine-actions" style={{ justifyContent: 'center', marginTop: '18px' }}>
              {temMaisProdutos ? (
                <button
                  type="button"
                  className="routine-btn routine-btn--soft"
                  onClick={carregarMaisProdutos}
                  disabled={carregandoProdutos}
                >
                  {carregandoProdutos ? 'Carregando...' : 'Carregar mais 5 produtos'}
                </button>
              ) : (
                <span className="routine-section-subtitle">Fim dos resultados.</span>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AbaMeuCatalogo;
